import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'

const API_PATH = 'api/v2/admins/sellers/outbounds/returns'

const SellerOutboundReturnsApiV2 = {

  /**
   * Index Seller Outbound Return
   * @param {object} tableState - ReactTable final state
   * @param {object} additionalFilters - A plain object to get customize filters outside `tableState`
   */
  get: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = API_PATH

    const response = axios.get(path, { params })
    return response
  },

  /**
   * Show Seller Outbound Return
   * @param {number} id - Seller Outbound Return ID
   */
  show: async (id) => {
    const path = `${API_PATH}/${id}`

    const response = axios.get(path)
    return response
  },

  /**
   * Create Seller Outbound Return
   * @param {object} payload - API payload
   */
  create: async (values) => {
    const path     = `${API_PATH}`
    const payload  = {
      seller_return: values
    }
    const response = axios.post(path, payload)
    return response
  },

  /**
   * Ship the Seller Outbound Return
   * @param {number} id - Seller Outbound Return ID
   * @param {object} payload - API payload
   */
  ship: async ({ id, values }) => {
    const path    = `${API_PATH}/${id}/ship`
    const payload = {
      seller_return: values
    }

    const response = axios.patch(path, payload)
    return response
  },

  /**
   * Edit Seller Outbound Return address
   * @param {number} id - Seller Outbound Return ID
   * @param {object} payload - API payload
   */
  update: async ({ id, values }) => {
    const path    = `${API_PATH}/${id}`
    const payload = {
      seller_return: values
    }

    const response = axios.patch(path, payload)
    return response
  }
}

export default SellerOutboundReturnsApiV2
